<template>
  <div class="textSlider-comp">
    <b-row>
     
      <b-col cols="12" lg="12">
         <div class="text-wrap mt4">
                            <h1 class="center-align">Our Aim</h1>
                         </div>
        <div class="TS-Slider">
          <div
              v-for="(slide, index) in carousel"
              :key="`${$route.name}_Slide_${index}`"
              class="slide"
            >
             
              <p v-html="slide.image" ></p>
            </div>
          <!-- <VueAgile v-if="carousel">
           
            <div
              v-for="(slide, index) in carousel"
              :key="`${$route.name}_Slide_${index}`"
              class="slide"
            >
             
              <p v-html="slide.image" ></p>
            </div>
          </VueAgile> -->
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { VueAgile } from "vue-agile";

export default {
  name: "TextSlider",
  props: {
    title: {
      type: String,
      default: "Slider Title",
    },
    text: {
      type: String,
      default: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    },
    button: {
      type: Boolean,
      default: false,
    },
    buttonText: {
      type: String,
      default: "Button",
    },
    carousel: {
      type: Array,
      default() {
        return [{}];
      },
    },
    link: {
      type: String,
      default: "/",
    },
  },
  components: {
    VueAgile,
  },
};
</script>

<style lang="scss">
$mobileViewBP: 1024px;
.textSlider-comp {
  margin-top: 4rem;
  .TS-Slider {
    margin-top: 4rem;
    .slide {
      align-items: center;
      color: #fff;
      display: flex;
      height: 300px;
      justify-content: center;
      width: 100%;
      background: transparent;
      p{
         color: #472884;
          font-family: 'Roboto';
          font-size: 32px;
          font-weight: 500;
          letter-spacing: -1px;
          line-height: 45px;
          text-align: center;
          @media screen and (max-width: $mobileViewBP) {
            font-size: 25px;
            line-height: 35px;
          }
          
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .agile{
        width: 100%;

        &__actions{
          margin-top: 20px;
           align-items: center;
            justify-content: center;
            .agile__nav-button {
                &.agile__nav-button--prev{
                  display: none;
                }
                &.agile__nav-button--next{
                  display: none;
                }
            }
        }

        &__nav-button{
          background: transparent;
          border: none;
          color: #ccc;
          cursor: pointer;
          font-size: 24px;
          transition-duration: .3s;

          &:hover{
            color: #888;
          }
        }

        &__dot{
          margin: 0 10px;
              align-items: center;
              
              display: flex;
              justify-content: center;
              width: 100%;

          button{ 
            background-color: #888;
            border: none;
            border-radius: 50%;
            cursor: pointer;
            display: block;
            height: 10px;
            font-size: 0;
            line-height: 0;
            margin: 0;
            padding: 0;
            transition-duration: .3s;
            width: 20px;
            height: 20px;
            min-height:20px;
          }

          &--current,
          &:hover{
            button{
              background-color: #472884;
            }
          }
        }
    }
  } 
}
</style>